import { FC, useState } from 'react';
import { v4 as uuid } from 'uuid';
import { useDispatch } from 'react-redux';
import { Box, Button, Form, FormField, Select, TextInput } from 'grommet';

import { addToGroceryList } from '../store';

interface FormState {
  title?: string;
  priority?: '1' | '2' | '3' | '4' | '5';
  amount?: number;
}

const formDefault: FormState = {
  title: '',
  priority: '5',
  amount: 1,
};

const FormModal: FC<{ onClose: () => void }> = ({ onClose }) => {
  const dispatch = useDispatch();
  const [value, setValue] = useState<FormState>(formDefault);

  return (
    <Box overflow="auto">
      <Box pad="xlarge">
        <Form
          value={value}
          onChange={(nextValue, { touched }) => {
            setValue(nextValue as FormState);
          }}
          onSubmit={(event) => {
            dispatch(
              addToGroceryList({
                ...(event.value as GroceryItem),
                id: uuid(),
                isHaving: false,
              }),
            );

            onClose();
            setValue(formDefault);
          }}
        >
          <FormField
            label="Title"
            name="title"
            required
            validate={{ regexp: /^[\w\d]/i }}
          />
          <FormField
            label="Amount"
            name="amount"
            component={TextInput}
            type="number"
            min={1}
          />
          <FormField
            label="Priority"
            name="priority"
            required
            component={Select}
            options={['1', '2', '3', '4', '5']}
          />
          <Box direction="row" justify="between" margin={{ top: 'medium' }}>
            <Button
              label="Close"
              onClick={() => {
                onClose();
                setValue(formDefault);
              }}
            />
            <Button type="submit" label="Save" primary />
          </Box>
        </Form>
      </Box>
    </Box>
  );
};

export default FormModal;
